import dynamic from 'next/dynamic';
import pkg from '../package.json';
import { PLUGIN_NAME } from './constants';
export default async function load(app) {
  app.events.once('load:custom:page-builder:component', addComponent => {
    addComponent({
      key: 'googlemaps',
      component: dynamic(() => import(/* webpackChunkName: "blazePbGoogleMaps" */'./GoogleMaps'))
    });
  });
  return {
    name: PLUGIN_NAME,
    version: pkg.version
  };
}
load.pluginName = PLUGIN_NAME;
//# sourceMappingURL=index.js.map